module.exports = id => `/god-catalog/${id}`
